<template>
  <div class="flex items-center space-x-1">
    <button 
      class="toolbar-btn" 
      @click="$emit('open-link-menu')" 
      :title="$t('AddLink')"
    >
      <i class="fas fa-link"></i>
    </button>
    <button 
      class="toolbar-btn" 
      @click="$emit('open-image-menu')" 
      :title="$t('AddImage')"
    >
      <i class="fas fa-image"></i>
    </button>
    <TableInsertButton 
      v-if="editor" 
      :editor="editor"
    />
  </div>
</template>

<script>
import TableInsertButton from "@/views/components/atoms/tiptap/Predefined/Buttons/Table/TableInsertButton.vue"

export default {
  name: 'ContentButtons',
  components: {
    TableInsertButton
  },
  props: {
    editor: {
      type: Object,
      required: true
    }
  }
}
</script> 